<div class="d-flex justify-content-center">
  <div class="alert alert-danger mt-3">
    <p>{{ errorMsg }}</p>
    <p>Please contact an Admin for assistance.</p>
    <a
      href="home"
      class="btn btn-sm btn-primary">Try Again</a>
  </div>
</div>
